import useAuth from "./useAuth";
import Constants from "../Configuration";
import {RequestType} from "../Services/ApiService";
import useProgress from "./useProgress";

export enum PluginType {
    Unknown = -1,
    Hero = 0,
    Utility = 1,
    Library = 2
}

export enum CostType {
    Free = 0,
    Buy = 1,
    Purchased = 2
}

export type IPlugin = {
    id: number;
    pluginName: string;
    authorName: string;
    createdTime: string;
    type: PluginType;
    costType: CostType;
    description: string;
    path: string;
};

export interface ITogglePlugin extends IPlugin {
    isEnabled: boolean;
    isLocal: boolean;
    isAutoCompile: boolean;
    isOwner: boolean;
    countOfUsers: number;
    youTubeLink: string;
    imageId: string;
}

const useScripts = () => {
    const {state} = useAuth();
    const {StartLoading: startToggleLoading, EndLoading: endToggleLoading, isLoading} = useProgress();

    const UpdateDescription = async (id: number, description: string, youtubeLink: string) => {
        try {
            startToggleLoading()
            await state.apiService.callApi(Constants.apiEndpoint + `manager/changePluginDescription`, {
                PluginId: id,
                Description: description,
                YoutubeLink: youtubeLink,
            }, RequestType.PUT);
        } catch (e) {
        } finally {
            endToggleLoading();
        }
    }

    return {UpdateDescription, isLoading};
}

export default useScripts;
